enum UserDialogFields {
	USERNAME = "username",
	PASSWORD = "password",
	ROLE = "role",
	DELETE = "delete",
	ADD = "add"
}

export default UserDialogFields;